/* eslint-disable no-param-reassign */
import { action, computed } from 'easy-peasy';
import { flow, get, has, reduce } from 'lodash/fp';

export default {
  event: null,
  timeSlot: '',
  isUserEligible: computed(
    [
      get('event'),
      (_, storeState) => get('programsOutreaches.data', storeState)
    ],
    (event, outreachesById) => {
      if (!event || !outreachesById) return true;
      const isUserEligible = has(`${event.id}`, outreachesById);

      return isUserEligible;
    }
  ),
  matchedAndEligibleProgramIds: computed(
    flow(
      get('event.trackingMethods'),
      reduce(
        (all, { id, isMatch, isGuestEligible }) =>
          isMatch && isGuestEligible ? [...all, id] : all,
        []
      )
    )
  ),
  set: action((state, { event, timeSlot }) => {
    state.event = event;
    state.timeSlot = timeSlot;
  }),
  clear: action(state => {
    state.event = null;
    state.timeSlot = '';
  })
};
